import React from "react";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BuildIcon from "@mui/icons-material/Build";
import BusinessIcon from "@mui/icons-material/Business";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import EventIcon from "@mui/icons-material/Event";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MapIcon from "@mui/icons-material/Map";
import ExpensesIcon from "@mui/icons-material/PaymentTwoTone";
import FuelIcon from "@mui/icons-material/EvStation";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import SettingsIcon from "@mui/icons-material/Settings";
import SpeedIcon from "@mui/icons-material/Speed";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import WarningIcon from "@mui/icons-material/Warning";
import WebIcon from '@mui/icons-material/Language';
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ConnectedIcon from '@mui/icons-material/ViewStream';
import { ReactComponent as BillingIcon } from "../../../assets/icons/icon-billing.svg";
import { ReactComponent as InvoiceIcon } from "../../../assets/icons/icon-invoice.svg";
import { ReactComponent as CreditNoteIcon } from "../../../assets/icons/icon-credit-note.svg";
import { ReactComponent as TaskManagerIcon } from "../../../assets/icons/Job-schedular-icon.svg";
import { ReactComponent as FleetTransferIcon } from "../../../assets/icons/vehicle-transfr-icon.svg";
import { ReactComponent as PCNIcon } from "../../../assets/icons/payment.svg";
import { ReactComponent as DamageMatrixIcon } from "../../../assets/icons/damageMatrix.svg";
import depositIcon from "../../../assets/icons/deposit-icon.svg"
import ConsolidatedInvoiceIcon from '../../../assets/icons/consolidated-icon-invoice.svg';
import InventoryIcon from '@mui/icons-material/Inventory';
import NoTransferIcon from '@mui/icons-material/NoTransfer';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { useSelector } from "react-redux";
import { IAppState } from "../../../store";


const NavBar = () => {
  const userState = useSelector((state: IAppState) => state.userReducer);  
  const isContractHire = userState && userState.organisation.bookingCategories.some((category) => category.isContractHire === true)
  const modules = [
  {
    name: "Dashboard",
    link: "/",
    Icon: <SpeedIcon style={{ fontSize: 18 }} />
  },
  {
    name: "Bookings",
    link: "/bookings",
    Icon: <CheckCircleOutlineIcon style={{ fontSize: 18 }} />,
  },
  {
    name: "Customers",
    Icon: <SupervisorAccountIcon style={{ fontSize: 18 }} />,
    items: [
      {
        name: "Individual",
        link: "/individual-customer",
        Icon: <PermIdentityIcon style={{ marginLeft: 10, fontSize: 18 }} />
      },
      {
        name: "Business",
        link: "/business-customer",
        Icon: <BusinessIcon style={{ marginLeft: 10, fontSize: 18 }} />
      }
    ]
  },
  {
    name: "Fleet",
    Icon: <DirectionsCarIcon style={{ fontSize: 18 }} />,
    items: [
      {
        name: "Fleet Dashboard",
        link: "/vehicle-dashboard",
        Icon: <MapIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Fleet Inventory",
        link: "/vehicle-inventory",
        Icon: <DirectionsCarIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Smartcar",
        link: "/smartcar",
        Icon: <ConnectedIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Fleet Transfer",
        link: "/fleet-transfer",
        Icon: <FleetTransferIcon
          style={{
            width: 20,
            height: 26,
            marginLeft: 8,
          }}
        />,
      },
      {
        name: "Vehicle Checklist",
        link: "/vehicle-checklist",
        Icon: <DoneAllIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Vehicle Scheduler",
        link: "/vehicle-scheduler",
        Icon: <EventIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Damages",
        link: "/vehicle-damage",
        Icon: <WarningIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Damage Matrix",
        link: "/vehicle-damage-matrix",
        Icon: <DamageMatrixIcon
          style={{
            width: 20,
            height: 20,
            marginLeft: 8,
          }}
        />,
      },
      {
        name: "Service",
        link: "/services-and-repair",
        Icon: <BuildIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      }
    ]
  },
  {
    name: "Asset",
    Icon: <InventoryIcon style={{ fontSize: 18 }} />,
    items: [
      {
        name: "Inventory",
        link: "/asset-inventory",
        Icon: <InventoryIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Damages",
        link: "/asset-damage",
        Icon: <WarningIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      },
      {
        name: "Service",
        link: "/asset-services",
        Icon: <BuildIcon style={{ marginLeft: 10, fontSize: 18 }} />,
      }
    ]
  },
  {
    name: "Billing",
    Icon: <BillingIcon
      style={{
        width: 20,
        height: 26,
      }}
    />,
    items: [
      {
        name: "Invoices",
        link: "/invoices",
        Icon: <InvoiceIcon
          style={{
            width: 20,
            height: 26,
            marginLeft: 8,
          }}
        />
      },
      {
        name: "Consolidated Invoices",
        link: "/consolidated-invoices",
        Icon: <img alt="" src={ConsolidatedInvoiceIcon}
          style={{
            width: 20,
            height: 26,
            marginLeft: 8,
          }}
        />
      },
      {
        name: "Credit Notes",
        link: "/credit-notes",
        Icon: <CreditNoteIcon
          style={{
            width: 20,
            height: 26,
            marginLeft: 8,
          }}
        />
      },
      {
        name: "Penalty Charge Notice",
        link: "/penalty-charge-notice",
        Icon: <PCNIcon
          style={{
            width: 20,
            height: 26,
            marginLeft: 8
          }}
        />
      },
      {
        name: "Pending Deposits",
        link: "/deposits",
        Icon: <img alt="" src={depositIcon}
          style={{
            width: 20,
            height: 26,
            marginLeft: 8,
          }}
        />
      }

    ]
  },
  {
    name: "Expenses",
    Icon: <ExpensesIcon style={{ fontSize: 18 }} />,
    link: "/expenses"
  },
  {
    name: "Reports",
    link: "/reports",
    Icon: <AssessmentIcon style={{ fontSize: 18 }} />,
  },
  {
    name: "Logistics",
    Icon: <LocalShippingIcon style={{ fontSize: 18 }} />,
    items: [
      {
        name: "Drivers",
        link: "/drivers",
        Icon: <span style={{ color: "white", marginLeft: 10 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C10.067 2 8.5 3.567 8.5 5.5C8.5 7.433 10.067 9 12 9C13.933 9 15.5 7.433 15.5 5.5C15.5 3.567 13.933 2 12 2ZM6.5 5.5C6.5 2.462 8.962 0 12 0C15.038 0 17.5 2.462 17.5 5.5C17.5 8.538 15.038 11 12 11C8.962 11 6.5 8.538 6.5 5.5ZM3 20.5C3 16.358 6.358 13 10.5 13H13.5C17.642 13 21 16.358 21 20.5V22C21 22.553 20.553 23 20 23C19.447 23 19 22.553 19 22V20.5C19 17.462 16.538 15 13.5 15H10.5C7.462 15 5 17.462 5 20.5V22C5 22.553 4.553 23 4 23C3.447 23 3 22.553 3 22V20.5Z" fill="#FFFFFF" />
          </svg>
        </span>
      },
      {
        name: "Driver Scheduler",
        link: "/driver-scheduler",
        Icon: (
          <span style={{ color: "white", marginLeft: 10 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C10.067 2 8.5 3.567 8.5 5.5C8.5 7.433 10.067 9 12 9C13.933 9 15.5 7.433 15.5 5.5C15.5 3.567 13.933 2 12 2ZM6.5 5.5C6.5 2.462 8.962 0 12 0C15.038 0 17.5 2.462 17.5 5.5C17.5 8.538 15.038 11 12 11C8.962 11 6.5 8.538 6.5 5.5ZM3 20.5C3 16.358 6.358 13 10.5 13H13.5C17.642 13 21 16.358 21 20.5V22C21 22.553 20.553 23 20 23C19.447 23 19 22.553 19 22V20.5C19 17.462 16.538 15 13.5 15H10.5C7.462 15 5 17.462 5 20.5V22C5 22.553 4.553 23 4 23C3.447 23 3 22.553 3 22V20.5Z" fill="#FFFFFF" />
              <rect x="15" y="3" width="4" height="2" rx="1" fill="#FFFFFF" />
              <rect x="5" y="3" width="4" height="2" rx="1" fill="#FFFFFF" />
              <rect x="4" y="7" width="16" height="12" rx="2" fill="#FFFFFF" />
              <rect x="6" y="10" width="3" height="3" rx="0.5" fill="#222222" />
              <rect x="11" y="10" width="3" height="3" rx="0.5" fill="#222222" />
              <rect x="16" y="10" width="3" height="3" rx="0.5" fill="#222222" />
            </svg>
          </span>
        )
      },
      {
        name: "Fleet Movement",
        link: "/movements",
        Icon: <span style={{ marginLeft: 10 }}><svg width="18px" version="1.1" id="Layer_1" x="0px" y="0px"
          viewBox="0 0 24 24" enable-background="new 0 0 24 24">
          <g id="surface1">
            <path fill="#010101" stroke="#F9F9FA" stroke-miterlimit="10" d="M9.9,11.4h1.5v0.7H9.9V11.4z" />
            <path stroke="#F9F9FA" stroke-miterlimit="10" d="M22.8,10.4l-2.6-0.3c-0.5-0.3-1-0.5-1.5-0.7c-1.7-0.7-3.4-1.1-5.3-1.1H13
		    c-2.1,0-4.2,0.5-6.1,1.5l-1.3,0.7c-1.5,0-3,0.4-4.3,1.1c-0.5,0.3-0.9,0.8-0.9,1.4V15c0,0.2,0.2,0.4,0.4,0.4h1.3
		    C2.5,16.4,3.8,17,5,16.6c0.6-0.2,1.2-0.7,1.4-1.3h10.1c0.4,1.1,1.7,1.7,2.9,1.3c0.6-0.2,1.2-0.7,1.4-1.3h0.1c0,0,0.1,0,0.1,0
		    l1.2-0.5c0.5-0.2,0.9-0.7,0.9-1.2v-2.8C23.1,10.6,23,10.4,22.8,10.4z M5.7,14.9c-0.2,0.8-1,1.2-1.8,1.1c-0.8-0.2-1.3-0.9-1.2-1.7
		    c0.2-0.8,1-1.2,1.8-1.1c0.7,0.1,1.2,0.7,1.2,1.4C5.7,14.7,5.7,14.8,5.7,14.9z M12.5,14.6h-6c0-1.2-1-2.1-2.3-2.1S2,13.4,2,14.6H1.2
		    v-1.7c0-0.3,0.2-0.6,0.5-0.8c1.2-0.7,2.6-1,4-1h6.8V14.6z M12.5,10.4H7.2l0.1,0c1.6-0.8,3.4-1.3,5.2-1.4V10.4z M13.3,9h0.2
		    c1.5,0,3,0.3,4.4,0.8l-0.7,0.6h-4V9z M20,14.9c-0.2,0.8-1,1.2-1.8,1.1c-0.8-0.2-1.3-0.9-1.2-1.7c0.2-0.8,1-1.2,1.8-1.1
		    c0.7,0.1,1.2,0.7,1.2,1.4C20.1,14.7,20.1,14.8,20,14.9z M22.3,11.4h-1.1v0.7h1.1v1.4c0,0.3-0.2,0.5-0.4,0.6l-1.1,0.4
		    c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
		    c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1
		    c0,0,0,0-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1
		    c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0
		    c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0c-1.3,0-2.3,0.9-2.3,2.1h-3v-3.5h4.2c0.1,0,0.2,0,0.3-0.1l1-0.9
		    c0.4,0.2,0.8,0.4,1.2,0.6c0,0,0.1,0,0.1,0l2.3,0.3V11.4z"/>
          </g>
          <text transform="matrix(1.0763 0 0 1 14.4355 11.5269)" fill="none" stroke="#FFFFFF" stroke-width="0.5" stroke-miterlimit="10" font-family="'Acme-Regular'" font-size="22.3448px">&gt;</text>
          <text transform="matrix(-1.0763 0 0 1 13.125 23.8594)" fill="none" stroke="#FFFFFF" stroke-width="0.5" stroke-miterlimit="10" font-family="'Acme-Regular'" font-size="22.3448px">&gt;</text>
        </svg></span>,
      },
      {
        name: "Driver Allocation Rules",
        link: "/driver-allocation-rules",
        Icon: (
          <span style={{ color: "white", marginLeft: 10 }}>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.56255 4.15625C6.56255 3.96506 8.5383 2.625 10.5 2.625C12.4618 2.625 14.4375 3.96506 14.4375 4.15625C14.4375 4.83875 14.3649 5.243 14.3037 5.46306C14.263 5.60744 14.1278 5.6875 13.9777 5.6875H7.02236C6.8723 5.6875 6.73711 5.60744 6.69642 5.46306C6.63517 5.243 6.56255 4.83875 6.56255 4.15625ZM9.8438 3.9375C9.72776 3.9375 9.61648 3.98359 9.53444 4.06564C9.45239 4.14769 9.4063 4.25897 9.4063 4.375C9.4063 4.49103 9.45239 4.60231 9.53444 4.68436C9.61648 4.76641 9.72776 4.8125 9.8438 4.8125H11.1563C11.2723 4.8125 11.3836 4.76641 11.4657 4.68436C11.5477 4.60231 11.5938 4.49103 11.5938 4.375C11.5938 4.25897 11.5477 4.14769 11.4657 4.06564C11.3836 3.98359 11.2723 3.9375 11.1563 3.9375H9.8438ZM7.01667 8.40788C5.5598 7.95725 5.9273 7.15225 6.48292 6.5625H14.6388C15.0833 7.13037 15.3217 7.89644 13.9782 8.35494C13.9928 8.48473 14 8.61642 14 8.75C13.9999 9.22393 13.9034 9.69288 13.7166 10.1284C13.5297 10.564 13.2564 10.957 12.9131 11.2838C12.5698 11.6105 12.1638 11.8642 11.7195 12.0293C11.2753 12.1944 10.8021 12.2676 10.3288 12.2444C9.85542 12.2212 9.3917 12.1021 8.96573 11.8944C8.53977 11.6866 8.16044 11.3945 7.85074 11.0358C7.54103 10.677 7.30741 10.2591 7.16404 9.80741C7.02067 9.35569 6.97053 8.87955 7.01667 8.40788ZM10.381 8.75C11.5369 8.75 12.4329 8.68875 13.1198 8.582C13.1233 8.63742 13.125 8.69342 13.125 8.75C13.1247 9.10033 13.0543 9.44705 12.9179 9.76973C12.7815 10.0924 12.5819 10.3845 12.3308 10.6289C12.0798 10.8732 11.7824 11.0648 11.4561 11.1924C11.1298 11.32 10.7813 11.381 10.4311 11.3718C10.0809 11.3626 9.73609 11.2834 9.41698 11.1388C9.09786 10.9943 8.8109 10.7873 8.57302 10.5301C8.33514 10.273 8.15114 9.97078 8.03187 9.64138C7.91259 9.31199 7.86046 8.96205 7.87855 8.61219C8.51861 8.70056 9.33892 8.75 10.381 8.75ZM14.1825 15.1375C13.7868 14.52 13.2421 14.0121 12.5986 13.6604C11.9551 13.3087 11.2334 13.1246 10.5 13.125C9.76639 13.1244 9.04439 13.3086 8.40061 13.6604C7.75683 14.0123 7.21199 14.5206 6.8163 15.1384C6.66911 14.9125 6.44367 14.7489 6.18323 14.679L5.33798 14.4528C5.05783 14.3777 4.7593 14.417 4.50808 14.5619C4.25686 14.7069 4.07351 14.9457 3.99836 15.2259L3.65886 16.4938C3.62168 16.6325 3.61219 16.7772 3.63094 16.9196C3.64969 17.062 3.69631 17.1994 3.76814 17.3238C3.83997 17.4482 3.93559 17.5572 4.04956 17.6446C4.16353 17.7321 4.2936 17.7962 4.43236 17.8334L5.27717 18.06C5.4193 18.0981 5.56764 18.1071 5.71333 18.0865C5.85902 18.0659 5.99905 18.0161 6.12505 17.9401C6.12539 18.0562 6.17182 18.1673 6.25412 18.2491C6.33641 18.3309 6.44783 18.3767 6.56386 18.3763C6.67989 18.376 6.79103 18.3295 6.87283 18.2472C6.95464 18.165 7.00039 18.0535 7.00005 17.9375V17.5C7.00005 17.3332 7.01142 17.1694 7.03417 17.0087L9.31092 17.619C9.4166 17.8452 9.58462 18.0366 9.79524 18.1707C10.0059 18.3047 10.2504 18.3759 10.5 18.3759C10.7497 18.3759 10.9942 18.3047 11.2048 18.1707C11.4155 18.0366 11.5835 17.8452 11.6892 17.619L13.9659 17.0087C13.9884 17.1694 13.9998 17.3332 14 17.5V17.9375C13.9995 18.0535 14.045 18.165 14.1266 18.2475C14.2083 18.33 14.3193 18.3766 14.4354 18.3772C14.5514 18.3778 14.6629 18.3322 14.7454 18.2506C14.8278 18.169 14.8745 18.0579 14.875 17.9419C15.12 18.0889 15.4228 18.1401 15.7207 18.06L16.566 17.8338C16.7047 17.7966 16.8348 17.7325 16.9488 17.6451C17.0627 17.5576 17.1584 17.4486 17.2302 17.3242C17.302 17.1998 17.3487 17.0625 17.3674 16.9201C17.3862 16.7777 17.3767 16.6329 17.3395 16.4942L16.9995 15.2263C16.9244 14.9462 16.741 14.7073 16.4898 14.5624C16.2386 14.4174 15.9401 14.3781 15.6599 14.4532L14.8147 14.6794C14.5548 14.7491 14.3298 14.9124 14.1825 15.1375ZM7.26386 16.1639C7.50033 15.5924 7.88381 15.0938 8.37535 14.7185C8.86689 14.3432 9.449 14.1047 10.0625 14.0271V15.8248C9.86636 15.8941 9.68946 16.0091 9.54645 16.1603C9.40344 16.3114 9.29842 16.4944 9.24005 16.6941L7.26386 16.1639ZM13.7362 16.1639C13.4998 15.5924 13.1163 15.0938 12.6247 14.7185C12.1332 14.3432 11.5511 14.1047 10.9375 14.0271V15.8248C11.333 15.9648 11.6419 16.2886 11.76 16.6941L13.7362 16.1639ZM10.5 17.5C10.6161 17.5 10.7274 17.4539 10.8094 17.3719C10.8915 17.2898 10.9375 17.1785 10.9375 17.0625C10.9375 16.9465 10.8915 16.8352 10.8094 16.7531C10.7274 16.6711 10.6161 16.625 10.5 16.625C10.384 16.625 10.2727 16.6711 10.1907 16.7531C10.1086 16.8352 10.0625 16.9465 10.0625 17.0625C10.0625 17.1785 10.1086 17.2898 10.1907 17.3719C10.2727 17.4539 10.384 17.5 10.5 17.5Z" fill="white" />
            </svg>
          </span>
        )
      }
    ]
  },
  {
    name: "Management Reports",
    link: "/management-reports",
    Icon: <AssessmentIcon style={{ fontSize: 18 }} />,
  },
  {
    name: "Web/Mobile Apps",
    link: "/apps",
    Icon: <WebIcon style={{ fontSize: 18 }} />,
  },
  {
    name: "Pricing",
    Icon: <LocalOfferIcon style={{ fontSize: 18 }} />,
    items: [
      {
        name: "Group & Price",
        link: "/vehicle-price-groups",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        )
      },
      {
        name: "Price Rules",
        link: "/price-rules",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        )
      },
      {
        name: "Vehicle Rate Cards",
        link: "/rate-cards",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        )
      },
      {
        name: "Addon Rate Cards",
        link: "/addon-rate-cards",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        )
      },
      {
        name: isContractHire ? "Contract Hire Plans" : "Subscription Plans",
        link: "/subscriptions",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        )
      }
    ]
  },
  {
    name: "Asset Lifecycle Mgmt",
    Icon: <DirectionsCarIcon style={{ fontSize: 18 }} />,
    items: [
      {
        name: "Procurements",
        link: "/procurements",
        Icon: <span style={{ marginLeft: 6 }}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 5.25003C2.80109 5.25003 2.61032 5.32905 2.46967 5.4697C2.32902 5.61035 2.25 5.80112 2.25 6.00003C2.25 6.19894 2.32902 6.38971 2.46967 6.53036C2.61032 6.67101 2.80109 6.75003 3 6.75003H4.665L6.633 14.625C6.80025 15.2925 7.398 15.75 8.08575 15.75H17.4382C18.1155 15.75 18.6908 15.3 18.8685 14.6475L20.8125 7.50003H19.242L17.4375 14.25H8.085L6.11775 6.37503C6.03649 6.05195 5.84916 5.76549 5.58576 5.56152C5.32236 5.35754 4.99813 5.24786 4.665 5.25003H3ZM16.5 15.75C15.2662 15.75 14.25 16.7663 14.25 18C14.25 19.2338 15.2662 20.25 16.5 20.25C17.7338 20.25 18.75 19.2338 18.75 18C18.75 16.7663 17.7338 15.75 16.5 15.75ZM9.75 15.75C8.51625 15.75 7.5 16.7663 7.5 18C7.5 19.2338 8.51625 20.25 9.75 20.25C10.9838 20.25 12 19.2338 12 18C12 16.7663 10.9838 15.75 9.75 15.75ZM12 5.25003V9.00003H9.75L12.75 12L15.75 9.00003H13.5V5.25003H12ZM9.75 17.25C10.173 17.25 10.5 17.577 10.5 18C10.5 18.423 10.173 18.75 9.75 18.75C9.327 18.75 9 18.423 9 18C9 17.577 9.327 17.25 9.75 17.25ZM16.5 17.25C16.923 17.25 17.25 17.577 17.25 18C17.25 18.423 16.923 18.75 16.5 18.75C16.077 18.75 15.75 18.423 15.75 18C15.75 17.577 16.077 17.25 16.5 17.25Z" fill="white" />
        </svg></span>,
      },
      {
        name: "Initiate De-Fleet",
        link: "/vehicle-defleet",
        Icon: <DirectionsCarIcon style={{ marginLeft: 10, fontSize: 18 }} />
      },
      {
        name: "De-Fleeted Vehicles",
        link: "/defleeted-vehicles",
        Icon: <NoTransferIcon style={{ marginLeft: 10, fontSize: 18 }} />
      }
    ]
  },
  {
    name: "Partners",
    link: "/partners",
    Icon: <span><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.1589 7.1589C21.4089 5.9089 20.8389 4.4489 20.1589 3.7389L17.1589 0.738904C15.8989 -0.511096 14.4489 0.0589036 13.7389 0.738904L12.0389 2.4489H9.4489C7.5489 2.4489 6.4489 3.4489 5.8889 4.5989L1.4489 9.0389V13.0389L0.738904 13.7389C-0.511096 14.9989 0.0589036 16.4489 0.738904 17.1589L3.7389 20.1589C4.2789 20.6989 4.8589 20.8989 5.4089 20.8989C6.1189 20.8989 6.7689 20.5489 7.1589 20.1589L9.8589 17.4489H13.4489C15.1489 17.4489 16.0089 16.3889 16.3189 15.3489C17.4489 15.0489 18.0689 14.1889 18.3189 13.3489C19.8689 12.9489 20.4489 11.4789 20.4489 10.4489V7.4489H19.8589L20.1589 7.1589ZM18.4489 10.4489C18.4489 10.8989 18.2589 11.4489 17.4489 11.4489H16.4489V12.4489C16.4489 12.8989 16.2589 13.4489 15.4489 13.4489H14.4489V14.4489C14.4489 14.8989 14.2589 15.4489 13.4489 15.4489H9.0389L5.7589 18.7289C5.4489 19.0189 5.2689 18.8489 5.1589 18.7389L2.1689 15.7589C1.8789 15.4489 2.0489 15.2689 2.1589 15.1589L3.4489 13.8589V9.8589L5.4489 7.8589V9.4489C5.4489 10.6589 6.2489 12.4489 8.4489 12.4489C10.6489 12.4489 11.4489 10.6589 11.4489 9.4489H18.4489V10.4489ZM18.7389 5.7389L17.0389 7.4489H9.4489V9.4489C9.4489 9.8989 9.2589 10.4489 8.4489 10.4489C7.6389 10.4489 7.4489 9.8989 7.4489 9.4489V6.4489C7.4489 5.9889 7.6189 4.4489 9.4489 4.4489H12.8589L15.1389 2.1689C15.4489 1.8789 15.6289 2.0489 15.7389 2.1589L18.7289 5.1389C19.0189 5.4489 18.8489 5.6289 18.7389 5.7389Z" fill="white" />
    </svg></span>,
  },
  {
    name: "Task Manager",
    link: "/user-jobs",
    Icon: <TaskManagerIcon
      style={{
        width: 20,
        height: 26,
      }}
    />
  },
  {
    name: "Settings",
    Icon: <SettingsIcon style={{ fontSize: 18 }} />,
    items: [
      {
        name: "Account",
        link: "/account-settings",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Add Ons",
        link: "/addons",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Protection Plans",
        link: "/protection-plans",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Insurance",
        link: "/insurance-settings",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Organisation",
        link: "/org-structure",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Users",
        link: "/users",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Roles",
        link: "/roles",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Policies",
        link: "/policies",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Rental Agreement",
        link: "/rental-agreement",
        Icon: <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
      },
      {
        name: isContractHire ? "Contract Hire" : "Subscription Agreement",
        link: "/subscription-agreement",
        Icon: <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
      },
      {
        name: "Document Types",
        link: "/document-types",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Payment & Integrations",
        link: "/integrations",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Marketplace",
        link: "/marketplace",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Service Task Items",
        link: "/service-task-items",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      },
      {
        name: "Email Settings",
        link: "/email-settings",
        Icon: (
          <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
        ),
      }
      //TODO: Bring back once we gave RO to define custom assets types and option to add custom fields for assets
      // {
      //   name: "Asset Types",
      //   link: "/asset-types",
      //   Icon: (
      //     <FiberManualRecordIcon style={{ marginLeft: 10, fontSize: 18 }} />
      //   ),
      // },
    ]
  },
];
return modules;
}
export default NavBar;
